import { API_AUTH } from "./common";

const DuNoChoVayApi = {
  list: ({ dateFrom, dateTo, kieuVay, tinhTrang }) =>
    API_AUTH.get(
      `bao-cao/du-no-cho-vay?dateFrom=${dateFrom}&dateTo=${dateTo}&kieuVay=${kieuVay}&tinhTrang=${tinhTrang}`,
      {}
    ),
  getListChiTietDuNo: (
    dateFrom,
    dateTo,
    kieuVay,
    tinhTrang,
    pageIndex,
    pageSize
  ) =>
    API_AUTH.get(
      `bao-cao/chi-tiet-du-no-cho-vay?dateFrom=${dateFrom}&dateTo=${dateTo}&kieuVay=${kieuVay}&tinhTrang=${tinhTrang}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
};

export default DuNoChoVayApi;
